// routes.ts — the editor's pages as ROUTES rather than tabs. They used to be a tab bar inside the
// left panel; they are top-menu links now, and the path is what selects the page.
//
// Kept in its own module so Header (which renders the links) and App (which maps a path back to a
// page) can share one list without importing each other.
export const EDITOR_LINKS = [
    { path: "/", label: "Welcome", tab: "welcome" },
    { path: "/generate", label: "Random Generation", tab: "generate" },
    // One page for both halves of a level. "Editor Levels" and "Game Levels" used to be separate
    // top-level tabs; they are sub-tabs inside this one now, under the environment picker that
    // decides which content they show (see pages/LevelsPage.tsx).
    { path: "/levels", label: "Levels", tab: "levels" },
    { path: "/level-editor", label: "Level Editor", tab: "editor" },
    // What the GAME is fetching, as opposed to what this editor holds. Its own page rather than a
    // corner of Levels: it answers a question about the outside world, and the answer has to stay
    // true even when nobody has published from here.
    // LEGACY: these are the Firebase Hosting level packs. The path stays /deployments so existing
    // links keep working; only the words say legacy.
    { path: "/deployments", label: "Legacy Deployments", tab: "deployments" },
    { path: "/sr-options", label: "SR Options", tab: "srOptions" },
];
/** Where "open this template in the editor" navigates to. */
export const LEVEL_EDITOR_PATH = "/level-editor";
/** Where "pick an environment" navigates to — the Levels page owns the environment list. */
export const LEVELS_PATH = "/levels";
/** The page a path selects, or null when the path is not an editor page (account, settings, …). */
export function tabForPath(pathname) {
    return EDITOR_LINKS.find((link) => link.path === pathname)?.tab ?? null;
}
